import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { skipWhile, switchMap, take } from 'rxjs/operators';

import { Subscription } from '@core/api';
import { APP_STATES, MarketingUpgradeService, initActions, initSelectors } from '@core/store';
import { SharedLayoutModule } from '@shared/layout';

@Component({
  selector: 'la-marketing-upgrade-entry-page',
  templateUrl: './marketing-upgrade-entry-page.component.html',
  styleUrls: ['./marketing-upgrade-entry-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedLayoutModule],
})
export class MarketingUpgradeEntryPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly marketingUpgrade = inject(MarketingUpgradeService);

  ngOnInit(): void {
    const tier = this.route.snapshot.queryParamMap.get('tier');

    let validatedTier: Subscription | undefined;
    if (tier) {
      validatedTier = validateSubscriptionTier(tier);
    }

    this.marketingUpgrade.set({
      ...(validatedTier && { tier: validatedTier }),
    });

    this.store
      .select(initSelectors.getAppStatus)
      .pipe(
        skipWhile((status) => status === APP_STATES.IDLE),
        take(1),
        switchMap((status) => {
          if (status !== APP_STATES.USER) {
            this.router.navigate(['/register']);
            return EMPTY;
          }

          this.store.dispatch(initActions.processMarketingSubscriptionUpgradeEntry());
          return EMPTY;
        })
      )
      .subscribe();
  }
}

const validateSubscriptionTier = (tier: string): Subscription => {
  const normalized = tier.toUpperCase();
  if (Object.values(Subscription).includes(tier.toUpperCase() as Subscription)) {
    return normalized as Subscription;
  }

  return undefined;
};
